var ProviderViews = require('./ProviderView');

var SearchProviderViews = require('./SearchProviderView');

module.exports = {
  ProviderViews: ProviderViews,
  SearchProviderViews: SearchProviderViews
};